import { Select } from 'antd';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useMemo } from 'react';
import { getSelectableStaffOptions } from 'pages/rrs/recycling-consignment-detail/modify-base-info.utils';

const QuoteStaff = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  const { staffSelectOptions } = useAppSelector(selectGlobalInfo);
  const activeStaffOptions = useMemo(
    () => getSelectableStaffOptions(staffSelectOptions),
    [staffSelectOptions],
  );
  return (
    <div className="flex items-center gap-2">
      <FormLabel required={false}>{i18n.t(LOCALS.quote_staff)}:</FormLabel>
      <Controller
        name={`productList.${index}.quoteStaffId`}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <Select
              className="w-full"
              showSearch
              allowClear
              placeholder={i18n.t(LOCALS.please_select) || ''}
              filterOption={(input, option) =>
                String(option?.label || '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={field.value}
              onChange={field.onChange}
              status={fieldState.error ? 'error' : undefined}
              options={activeStaffOptions}
            />
            {fieldState.error?.message && (
              <div className="text-xs text-red-500 leading-5">
                {fieldState.error.message}
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default QuoteStaff;
